import { _ as __rest } from './tslib.es6-9c37295f.js';
import React__default from 'react';
import { M as MobileBottomNavigationIcon, S as StyledMobileBottomNavigation } from './MobileBottomNavigationIcon-72611c56.js';
import './index-bca4f215.js';
import '@mantine/core';
import './other-82ea32cf.js';
import './miscTheme.js';
import '@emotion/react';
import '@emotion/styled';
import './utils-da0db738.js';

const MobileBottomNavigationWrapper = (_a) => {
    var { children, isCollapsed = false, template = 'homepage', refObject } = _a, rest = __rest(_a, ["children", "isCollapsed", "template", "refObject"]);
    return (React__default.createElement(StyledMobileBottomNavigation, Object.assign({ "data-is-collapsed": isCollapsed, "data-template": template, ref: refObject }, rest), children));
};
const MobileBottomNavigation = MobileBottomNavigationWrapper;
MobileBottomNavigation.Icon = MobileBottomNavigationIcon;

export { MobileBottomNavigation };
